import {Icon, Typography} from '@sollapay/ui/components';
import {formatDateTimeLocalized, formatRelativeTimeLocalized} from '@sollapay/utils';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface HandledLabelProps {
  handledAt: string;
  handledByName?: string | null;
}

export const HandledLabel: FC<HandledLabelProps> = ({handledAt, handledByName}) => {
  const {t, i18n} = useTranslation('trustAccounts');

  const time = formatRelativeTimeLocalized(handledAt, i18n.language);
  const byLine = handledByName
    ? t('view.instructions.handled.byLine', {name: handledByName, time})
    : time;

  return (
    <div data-slot="handled-label" className="flex min-w-0 flex-col items-start gap-1">
      <div data-slot="status" className="text-text-success flex items-center gap-1">
        <Icon name="check-circle" width={16} height={16} />
        <Typography size="sm" weight="medium" className="text-inherit">
          {t('view.instructions.handled.label')}
        </Typography>
      </div>
      <Typography
        size="xs"
        color="tertiary"
        title={formatDateTimeLocalized(handledAt, i18n.language)}
      >
        {byLine}
      </Typography>
    </div>
  );
};
